import { useCallback } from 'react';
import { messages } from 'i18n';
import { Link } from 'components/mui-index';
import { ERROR_TOAST_DURATION, useToast } from './useToast';

export const usePortalFailureNotification = () => {
  const { showToast } = useToast();

  const showFailureNotification = useCallback(
    (portalUrl: string, message: string) => {
      showToast(
        'error',
        {
          message: (
            <>
              {message}{' '}
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(portalUrl, '_blank');
                }}
                sx={{ color: 'inherit', cursor: 'pointer' }}
              >
                {messages.portalAutomation.openPortalManually}
              </Link>
            </>
          ),
        },
        { autoHideDuration: ERROR_TOAST_DURATION },
      );
    },
    [showToast],
  );

  return { showFailureNotification };
};
